.has-border {
  border-bottom: 1px solid #262d40;
}
.no-border {
  border: none;
}
.modal-title {
  font-size: 18px;
}
.btn-wallet {
  height: 60px;
  border-radius: 8px;
  border: 1px solid #262d40;
  display: inline-flex;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
  background: transparent;
  transition: all 0.3s;
  color: #fff;
  padding-left: 1rem;
  &:hover {
    background: #090d1a;
    color: #0099e6;
    .icon-wallet {
      box-shadow: 0 0 12px 0px #0099e6;
    }
  }
}
.icon-wallet {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  box-sizing: content-box;
  border: 2px solid #fff;
  background-color: #fff;
  margin-right: 12px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 30px;
  transition: all 0.3s;
  background-image: url(./images/wallet-icon.png);
  &.icon-wallet-stoic {
    background-position: 0 center;
  }
  &.icon-wallet-plug {
    background-position: -30px center;
  }
  &.icon-wallet-AstroX {
    background-position: -60px center;
  }
  &.icon-wallet-InfinityWallet {
    background-position: -90px center;
  }
  &.icon-wallet-NFID {
    background-position: right center;
  }
}
.loading-border {
  width: 4.5rem;
  height: 4.5rem;
  padding: 2px;
  background-image: linear-gradient(
    rgba(47, 144, 255, 0.8) 10%,
    rgba(0, 0, 0, 0.05) 25%
  );
  border-radius: 50%;
  animation: loading 2s linear infinite;
  position: relative;
  .loading-text {
    width: 100%;
    height: 100%;
    display: block;
    background-color: rgb(var(--bs-info-rgb));
    border-radius: 50%;
    font-size: 0;
  }
}
.btn-try-again {
  background: none;
  border: none;
  color: #5f7195;
  transition: color 0.3s;
  display: inline-flex;
  align-items: center;
  .icon-try-again {
    display: inline-block;
    width: 1.25rem;
    height: 1.25rem;
    margin-right: 5px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAAXNSR0IArs4c6QAAAMNQTFRFAAAAqqqqf3+/YH+fcXGqdHSian+qYnadaXiWY3GcaHSXZnqZZHabYXKVY3OcZXKaYHGZY3KXYHKWX3WXYHWWYHSXYnOWYHOVX3KXYHKWYXKVYXGWYXKXX3KXX3GXYXKVYHOWX3KVX3GWYHKVYHGWYXKXYHKVYHKVYHKWYHKVYHKWX3KVYHKWX3KWYHKVYHGWX3KVX3KVX3GVX3KWX3GWX3KVYHKWX3GWYHKWX3GVYHKWYHGWX3KVX3GWYHKVX3GWX3GVwLx1GAAAAEB0Uk5TAAMECAkLDA0REhYZHB0fJi0xODs9QElSU1VXYWluc3R6e36ChYmYmpykrK6vsbe/wcPGzNHZ4ubw8/f6+/z9/rOSWLEAAAE8SURBVDjLzZTZVoQwEETbZVBRwFEZFBVxwWFRERWFqEn9/1f5ggMMSeDJYz01nMsJXdVpov+imRfnZV2XeezNNNg8Y1iJZXMFZicCvAhcxzAcNyg4RGLLuEUFFpntsxkxVIshF3CkVv+VlYIHAw4iHH4dCqyRCy582f/4gvdOtyuE8g6vUXU7SpCqLEuRdPwTzFKBFhOtnw+I1ClEyFa5MW6qQZOz3zQ9FLr8C3hNFSPQgVeImyqHqwNd5E1VwtGBDsqmqmEQEW2fykEDdVMxbBERLXErBXdW4Af2iegM7HDk6FccE9kVLsaaWeKSNl/aAJT2nOOJ7vC+O2r43ueXz79PxiOkRwjcTBgKOgKeN6aMGd2/HUwaXI3WroJS65dLpeF1lfchWwAS/xQrpTdY2iXV0cjaazW6SP9WPy+9L0G/J+Z7AAAAAElFTkSuQmCC);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
}

@keyframes loading {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
